import React from "react"
import { Link } from "gatsby"
import Button from "./lib/Button"
import Icon from "./lib/Icon"

export { default as Logo } from "./lib/Logo"
export {
  LogoSign,
  LogoSignDown,
  LogoSignUp,
  LogoTypeEnglish,
  LogoTypePersian,
  LogoFull,
} from "./lib/Logo"
export { default as Button } from "./lib/Button"
export { default as ListenToButton } from "./lib/ListenToButton"
export { default as Header } from "./lib/Header"
export { default as SnakePanel } from "./lib/SnakePanel"
export { default as HeroCover } from "./lib/HeroCover"
export { default as Card } from "./lib/Card"
export { default as EpisodeCard } from "./lib/EpisodeCard"
export { default as PostCard } from "./lib/PostCard"
export { default as Icon } from "./lib/Icon"
export { default as ReadButton } from "./lib/ReadButton"
export { default as Container } from "./lib/Container"
export { default as Section } from "./lib/Section"
export { default as ActionBar } from "./lib/ActionBar"
export { ActionBarForArticle } from "./lib/ActionBar"
export { default as Footer } from "./Footer"

export const App_CastBox = () => (
  <div className="listen_to__logo">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.639 40">
      <g transform="translate(-4.286 0)">
        <path
          d="M4.295,20V11.633a3.05,3.05,0,0,1,1.628-2.84L19.879.525A3.065,3.065,0,0,1,23.3.52l14.016,8.3a3.051,3.051,0,0,1,1.606,2.8V28.356a3.043,3.043,0,0,1-1.59,2.8L23.274,39.491a2.982,2.982,0,0,1-3.315.013l-14.027-8.3a3.082,3.082,0,0,1-1.646-2.894Zm20.878-.111,0-3.84a1.139,1.139,0,0,0-1.075-1.235A1.154,1.154,0,0,0,22.774,16l-.01,2.519a.666.666,0,0,1-.856.719c-.4-.089-.512-.378-.51-.753l0-3.337a1.213,1.213,0,1,0-2.42-.092l-.009,2.708c-.006.5-.231.734-.654.749-.437.015-.717-.247-.746-.75l-.006-.937a1.062,1.062,0,0,0-.766-1.037,1.182,1.182,0,0,0-1.612,1.129l-.01,2.394a.636.636,0,0,1-.661.685.653.653,0,0,1-.719-.633c-.017-.124,0-.253-.015-.377A1.214,1.214,0,0,0,12.6,17.9a1.186,1.186,0,0,0-1.184,1.091v3.778a1.17,1.17,0,0,0,1.18,1.091,1.208,1.208,0,0,0,1.187-1.087c.019-.145-.037-.327.031-.433.137-.211.309-.473.522-.542A.793.793,0,0,1,14.99,22a.967.967,0,0,1,.183.63l.012,3.715a1.2,1.2,0,0,0,1.745,1.059,1.138,1.138,0,0,0,.641-1.13l0-4.912c0-.764.229-1.106.726-1.1.475.006.687.325.687,1.061l0,2.2a1.181,1.181,0,0,0,1.19,1.264A1.2,1.2,0,0,0,21.4,23.5l.005-1.7c.01-.515.266-.8.689-.79s.67.289.677.8l.008,1.952a1.2,1.2,0,1,0,2.394-.1l0-3.781Zm3.8,1.335,0-2.139a1.15,1.15,0,0,0-1.142-1.231,1.1,1.1,0,0,0-1.259,1.108l.008,4.528a1.153,1.153,0,0,0,1.255,1.126,1.169,1.169,0,0,0,1.139-1.252V21.224Zm1.4.595v.565a1.2,1.2,0,0,0,2.379.1,6.887,6.887,0,0,0,0-1.316,1.194,1.194,0,0,0-2.379.086c-.011.187,0,.377,0,.565Z"
          transform="translate(0 0)"
        />
        <path
          d="M29.449,28.186l0,3.778a1.2,1.2,0,1,1-2.394.1l-.008-1.952c-.006-.514-.254-.8-.677-.8s-.679.275-.689.79l0,1.7a1.2,1.2,0,0,1-1.229,1.294,1.178,1.178,0,0,1-1.19-1.264l0-2.2c0-.736-.206-1.055-.687-1.061-.5-.006-.725.335-.726,1.1l0,4.912a1.137,1.137,0,0,1-.641,1.13,1.2,1.2,0,0,1-1.745-1.059l-.013-3.715a.965.965,0,0,0-.183-.63.8.8,0,0,0-.656-.208c-.212.062-.384.33-.522.542-.062.106-.014.287-.031.433a1.209,1.209,0,0,1-1.187,1.087,1.173,1.173,0,0,1-1.18-1.091V27.282a1.187,1.187,0,0,1,1.184-1.091,1.215,1.215,0,0,1,1.187,1.087c.015.124,0,.253.015.377a.656.656,0,0,0,.719.633.637.637,0,0,0,.661-.685l.01-2.394a1.183,1.183,0,0,1,1.612-1.129,1.061,1.061,0,0,1,.766,1.037l.006.937a.694.694,0,0,0,.746.75c.422-.015.647-.253.654-.749l.009-2.708a1.213,1.213,0,1,1,2.42.092l0,3.337c0,.374.106.664.51.753a.666.666,0,0,0,.856-.719l.01-2.519a1.154,1.154,0,0,1,1.32-1.187,1.14,1.14,0,0,1,1.075,1.235l0,3.844Zm3.8,1.336,0,2.139a1.172,1.172,0,0,1-1.139,1.252,1.152,1.152,0,0,1-1.255-1.126l-.008-4.528a1.109,1.109,0,0,1,1.259-1.108,1.148,1.148,0,0,1,1.142,1.231l0,2.139Zm1.4.594,0-.565a1.194,1.194,0,0,1,2.379-.086,6.91,6.91,0,0,1,0,1.316,1.2,1.2,0,0,1-2.379-.1c-.01-.187,0-.377,0-.565Z"
          transform="translate(-4.277 -8.291)"
          fill="none"
        />
      </g>
    </svg>
  </div>
)

export const App_GooglePodcast = () => (
  <div className="listen_to__logo">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <path
        d="M4.989,209.04v2.721a2.495,2.495,0,1,1-4.989,0V209.04a2.495,2.495,0,1,1,4.989,0Z"
        transform="translate(0 -190.4)"
      />
      <path
        d="M448,209.111q0-.035,0-.071a2.495,2.495,0,0,1,4.989,0c0,.024,0,.047,0,.071h0v2.721h0a2.495,2.495,0,0,1-4.987,0h0V209.11h0Z"
        transform="translate(-412.989 -190.4)"
      />
      <path
        d="M115.534,120.709v2.731a2.495,2.495,0,1,1-4.989,0v-2.731a2.495,2.495,0,1,1,4.989,0Zm0-16.387v8.933h0a2.494,2.494,0,0,1-4.988,0h0v-8.933a2.495,2.495,0,1,1,4.989,0Z"
        transform="translate(-101.906 -93.881)"
      />
      <path
        d="M337.455,107.034a2.495,2.495,0,0,0,4.989,0v-2.721a2.495,2.495,0,0,0-4.989,0Z"
        transform="translate(-311.083 -93.859)"
      />
      <path
        d="M224,5.227a2.495,2.495,0,1,0,4.989,0V2.5A2.495,2.495,0,1,0,224,2.5Zm0,29.545a2.495,2.495,0,1,1,4.989,0V37.5a2.495,2.495,0,1,1-4.989,0Z"
        transform="translate(-206.495)"
      />
      <path
        d="M337.455,235.222a2.495,2.495,0,0,1,4.989,0v8.844a2.495,2.495,0,1,1-4.989,0Z"
        transform="translate(-311.083 -214.524)"
      />
      <path
        d="M228.989,133.4v14.514a2.495,2.495,0,0,1-4.989,0V133.4a2.495,2.495,0,0,1,4.989,0Z"
        transform="translate(-206.495 -120.661)"
      />
    </svg>
  </div>
)

export const App_Spotify = () => (
  <div className="listen_to__logo">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <path d="M20,0A20,20,0,1,0,40,20,20,20,0,0,0,20,0Zm9.172,28.845a1.246,1.246,0,0,1-1.714.415c-4.7-2.87-10.608-3.518-17.569-1.928A1.247,1.247,0,1,1,9.333,24.9c7.618-1.74,14.154-.991,19.425,2.23A1.247,1.247,0,0,1,29.172,28.845ZM31.619,23.4a1.56,1.56,0,0,1-2.145.513C24.1,20.61,15.9,19.653,9.545,21.583A1.559,1.559,0,1,1,8.639,18.6C15.9,16.4,24.932,17.463,31.1,21.257a1.558,1.558,0,0,1,.514,2.144Zm.21-5.672c-6.447-3.828-17.081-4.18-23.236-2.313a1.87,1.87,0,1,1-1.085-3.58c7.065-2.144,18.809-1.73,26.23,2.675a1.871,1.871,0,0,1-1.909,3.218Z" />
    </svg>
  </div>
)

export const App_ApplePodcast = () => (
  <div className="listen_to__logo">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
    >
      <path
        d="M-5824-2308a19.883,19.883,0,0,1-7.786-1.572,19.928,19.928,0,0,1-6.357-4.286,19.921,19.921,0,0,1-4.286-6.357A19.872,19.872,0,0,1-5844-2328a19.874,19.874,0,0,1,1.572-7.785,19.933,19.933,0,0,1,4.286-6.357,19.931,19.931,0,0,1,6.357-4.287A19.877,19.877,0,0,1-5824-2348a19.87,19.87,0,0,1,7.785,1.572,19.931,19.931,0,0,1,6.357,4.287,19.939,19.939,0,0,1,4.286,6.357A19.874,19.874,0,0,1-5804-2328a19.872,19.872,0,0,1-1.572,7.785,19.921,19.921,0,0,1-4.286,6.357,19.928,19.928,0,0,1-6.357,4.286A19.878,19.878,0,0,1-5824-2308Zm.025-4.656h0l.112,0a3.112,3.112,0,0,0,.661-.071,2.027,2.027,0,0,0,1.481-1.292,9.564,9.564,0,0,0,.491-2.253c.2-1.35.435-3.335.547-4.617a18.586,18.586,0,0,0,.094-2.614,2.951,2.951,0,0,0-.241-1.113,1.974,1.974,0,0,0-.639-.7l-.049-.034-.012-.008-.038-.027a4.024,4.024,0,0,0-2.638-.791h-.037c-1.652.007-2.849.6-3.284,1.615-.327.77-.2,3.25.365,7.172.359,2.491.589,3.468,1.165,3.983a2.36,2.36,0,0,0,.248.252,2.436,2.436,0,0,0,1,.425,3.186,3.186,0,0,0,.662.07Zm-.258-31.009a14.031,14.031,0,0,0-5.517,1.124,14.015,14.015,0,0,0-4.692,3.249,14.016,14.016,0,0,0-3.653,7.174,18.48,18.48,0,0,0,.054,5.067,13.963,13.963,0,0,0,7.719,10.019l.069.047a11.041,11.041,0,0,0,1.493.639.1.1,0,0,0,.083-.033c.063-.07.065-.25.01-.74-.107-.982-.217-1.183-.786-1.427a11.357,11.357,0,0,1-1.373-.786,12.747,12.747,0,0,1-5.321-7.521,16.971,16.971,0,0,1,0-5.56,12.526,12.526,0,0,1,3.417-5.951,12.523,12.523,0,0,1,6.037-3.261,15.765,15.765,0,0,1,2.5-.2,15.765,15.765,0,0,1,2.5.2,12.442,12.442,0,0,1,5.938,3.146,12.432,12.432,0,0,1,3.436,5.775,15.578,15.578,0,0,1,.079,5.84,12.747,12.747,0,0,1-3.347,5.893,12.975,12.975,0,0,1-3.347,2.391c-.561.236-.68.45-.8,1.427-.048.439-.059.66.008.735a.1.1,0,0,0,.084.032,16.753,16.753,0,0,0,3.894-2.1,14.139,14.139,0,0,0,5.4-8.828,19.7,19.7,0,0,0-.013-4.772,14.084,14.084,0,0,0-3.365-6.88,14.094,14.094,0,0,0-6.466-4.106A14.088,14.088,0,0,0-5824.232-2343.666Zm.044,4.625a11.532,11.532,0,0,0-2.841.355,9.762,9.762,0,0,0-6.346,6.7,10.961,10.961,0,0,0-.013,4.533,9.98,9.98,0,0,0,3.119,5l.055.018a4.81,4.81,0,0,0,.854.6,2.681,2.681,0,0,0,.1-1.012v-1.013l-.688-.827a7.584,7.584,0,0,1,.44-10.369,7.371,7.371,0,0,1,4.188-2.093,5.163,5.163,0,0,1,1.179-.136,5.16,5.16,0,0,1,1.234.15,7.284,7.284,0,0,1,4.041,2.077,7.562,7.562,0,0,1,2.264,5.1,7.565,7.565,0,0,1-1.837,5.271l-.693.827v1.006a3.37,3.37,0,0,0,.079,1,8.3,8.3,0,0,0,2.16-1.917,9.362,9.362,0,0,0,2.027-4.8,9.52,9.52,0,0,0-7.292-10.289,11.52,11.52,0,0,0-2.023-.179Zm-.031,4.987a3.481,3.481,0,0,0-1.408.3,3.243,3.243,0,0,0-1.854,2.907,3.108,3.108,0,0,0,1.17,2.546,3.3,3.3,0,0,0,2.3.921,3.33,3.33,0,0,0,3.327-3.326,3.332,3.332,0,0,0-3.108-3.318A3.492,3.492,0,0,0-5824.22-2334.055Z"
        transform="translate(5844 2348.001)"
      />
    </svg>
  </div>
)

export const App_Overcast = () => (
  <div className="listen_to__logo">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 83.454 83.457">
  <path id="Subtraction_1" data-name="Subtraction 1" d="M8231.728-697.54a41.467,41.467,0,0,1-16.243-3.279,41.59,41.59,0,0,1-13.264-8.943,41.6,41.6,0,0,1-8.941-13.265A41.471,41.471,0,0,1,8190-739.271a41.458,41.458,0,0,1,3.279-16.24,41.583,41.583,0,0,1,8.941-13.263,41.591,41.591,0,0,1,13.264-8.943,41.464,41.464,0,0,1,16.243-3.28,41.451,41.451,0,0,1,16.241,3.28,41.612,41.612,0,0,1,13.265,8.943,41.6,41.6,0,0,1,8.941,13.263,41.465,41.465,0,0,1,3.279,16.24,41.478,41.478,0,0,1-3.279,16.244,41.587,41.587,0,0,1-8.941,13.265,41.59,41.59,0,0,1-13.265,8.943A41.454,41.454,0,0,1,8231.728-697.54Zm.386-74.182a32.637,32.637,0,0,0-12.783,2.581,32.722,32.722,0,0,0-10.437,7.038,32.712,32.712,0,0,0-7.038,10.438,32.623,32.623,0,0,0-2.581,12.783,32.628,32.628,0,0,0,2.581,12.783,32.718,32.718,0,0,0,7.038,10.44,32.722,32.722,0,0,0,10.438,7.039,32.63,32.63,0,0,0,12.783,2.581v-8.212a24.478,24.478,0,0,1-9.587-1.936,24.539,24.539,0,0,1-7.829-5.279,24.552,24.552,0,0,1-5.278-7.83,24.485,24.485,0,0,1-1.936-9.588,24.48,24.48,0,0,1,1.936-9.587,24.55,24.55,0,0,1,5.278-7.829,24.539,24.539,0,0,1,7.829-5.278,24.478,24.478,0,0,1,9.587-1.936,24.473,24.473,0,0,1,9.588,1.936,24.544,24.544,0,0,1,7.83,5.278,24.557,24.557,0,0,1,5.277,7.829,24.5,24.5,0,0,1,1.935,9.587h8.21a32.629,32.629,0,0,0-2.581-12.783,32.712,32.712,0,0,0-7.038-10.438,32.722,32.722,0,0,0-10.437-7.038A32.637,32.637,0,0,0,8232.113-771.722Zm0,13.137a19.593,19.593,0,0,0-7.67,1.548,19.636,19.636,0,0,0-6.262,4.222,19.632,19.632,0,0,0-4.223,6.263,19.579,19.579,0,0,0-1.548,7.67,19.581,19.581,0,0,0,1.548,7.67,19.641,19.641,0,0,0,4.223,6.264,19.637,19.637,0,0,0,6.262,4.224,19.583,19.583,0,0,0,7.67,1.549v-7.168a12.459,12.459,0,0,1-8.867-3.673,12.455,12.455,0,0,1-3.672-8.866,12.455,12.455,0,0,1,3.672-8.867,12.457,12.457,0,0,1,8.867-3.672,12.456,12.456,0,0,1,8.867,3.672,12.455,12.455,0,0,1,3.672,8.867h7.163a19.586,19.586,0,0,0-1.548-7.67,19.632,19.632,0,0,0-4.223-6.263,19.636,19.636,0,0,0-6.262-4.222A19.593,19.593,0,0,0,8232.113-758.585Z" transform="translate(-8190 780.997)"/>
</svg>

  </div>
)

export const Tag = ({
  children,
  color = "secondary",
  Tag = "div",
  className,
  ...props
}) => {
  return (
    <Tag {...props} className={`tag tag--${color} ${className || ""}`}>
      {children}
    </Tag>
  )
}

export const Main = ({ children, ...props }) => {
  return (
    <main {...props} role="main">
      {children}
    </main>
  )
}

export const Heading = ({ title, icon, color = "primary" }) => {
  return (
    <header
      className="episode_page__heading"
      style={{ color: `var(--${color})` }}
    >
      <Icon name={icon} />
      <h4>{title}</h4>
    </header>
  )
}
